import Swiper from 'swiper/js/swiper.min';
import '../misc/navigation';
import {TimelineMax} from 'gsap';

export default {
  init() {
    // JavaScript to be fired on all pages
    new LogoSwiper();
    new FixTextarea();

    // Home intro animation full - Desktop
    function pageFadeAnimationFullDesktop() {
      // Declare variables
      let internalBodyOverLay = $('.internal-body-overlay');

      // Timeline animation
      let introAnimFullTL = new TimelineMax({paused: true});
      introAnimFullTL
          .to(internalBodyOverLay, 1, {autoAlpha: 0, delay: 1, ease: Power4.easeInOut});
      return introAnimFullTL;
    }
    // Store a reference to the timeline that was created to control it later
    let pageFadeAnimationFullDesktopController = pageFadeAnimationFullDesktop();


    function pageFade() {
      pageFadeAnimationFullDesktopController.timeScale(1).play();
    }

    $(document).ready(pageFade);

    $('.lp-button').click(function(e){
      e.preventDefault();
      $('#lpGetQuoteModal').fadeIn();
    });

    $('.close-modal').click(function(){
      $('#lpGetQuoteModal').fadeOut();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


//-------------------------------------------------------
// Logo Swiper
//-------------------------------------------------------
function LogoSwiper()
{
  let self = this;

  this.init = function() {
    self.gallery = new Swiper('.logo-slide', {
      slidesPerView: 'auto',
      loop: true,
      centeredSlides: true,
      spaceBetween: 60,
      speed: 2000,
      effect: 'slide',
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      breakpoints: {
        700: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
        1200: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
        1800: {
          slidesPerView: 8,
          spaceBetween: 50,
        },
      },
    });
  };

  setTimeout(self.init, 1000);
}

//-------------------------------------------------------
// LP Colors Swiper
//-------------------------------------------------------
/* eslint-disable */
let swiper = new Swiper(".lp-colors", {
  slidesPerView: 'auto',
      loop: true,
      centeredSlides: true,
      spaceBetween: 60,
      speed: 2000,
      effect: 'slide',
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      breakpoints: {
        700: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
      },
});
/* eslint-enable */

//-------------------------------------------------------
// Fix small textarea
//-------------------------------------------------------
function FixTextarea()
{
  let self = this;

  this.init = function() {
    self.fix_small_textareas();
    self.event_listeners();
  };

  this.event_listeners = function() {
    jQuery(document).bind('gform_post_render', function(){
      self.fix_small_textareas();
    });
  };

  this.fix_small_textareas = function() {
    jQuery('textarea.small').attr('rows', 4);
  };

  self.init();
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js